export const types = {
  SHIPMENT_MASTER: "SHIPMENT_MASTER",
  SHIPMENT_MASTER_SUCCESS: "SHIPMENT_MASTER_SUCCESS",
};
